import type { DropdownMultiselectOptionProps } from './types'
import { OnDismissClickType, Token } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { DropdownMultiselectContext } from './context'

export function SelectedValue({ children, className, value }: DropdownMultiselectOptionProps) {
  const { selectedValues, removeOption } = React.useContext(DropdownMultiselectContext)

  const handleRemoveClick: OnDismissClickType = (value, e) => {
    e.preventDefault()
    removeOption(value)
    e.stopPropagation()
  }

  if (!selectedValues.includes(value))
    return null

  return (
    <Token value={value} className={className} dismissible onDismissClick={handleRemoveClick}>
      {children}
    </Token>
  )
}
